import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { generateEInvoice, getPendingPaymentLedgerList, viewCNDNInvoice, generateInvoice, updateLedgerEntry } from '@/api/ledgers';
import Pagination from '@/components/Pagination/index.vue';
import { getDealerById, searchDealers } from '@/api/dealers';
import { getQuery } from '@/utils';
import Inr from '@/components/Inr/index.vue';
import { getAgents, getAgentsBranchWise } from '@/api/agents';
import { AdminModule } from '@/store/modules/admin';
import moment from 'moment';
import { getBranches } from '@/api/locations/branches';
import { BranchAgentService } from '@/services/branch-agent-service';
import { cleanListQuery, isAdmin, isPaymentManager, isSuperAdmin } from '@/common';
import * as XLSX from 'xlsx';
import { getAccountManagers } from '@/api/admins';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.BASE_URL = process.env.VUE_APP_BASE_API;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.dealerList = [];
    this.agentList = [];
    this.listLoading = false;
    this.branchListLoading = false;
    this.branchList = [];
    this.dealerListLoading = false;
    this.agentListLoading = false;
    this.dateRange = {
      start: '',
      end: ''
    };
    this.openingBalance = 0;
    this.closingBalance = 0;
    this.isAgent = false;
    this.loggedInAdmin = null;
    this.isReadOnly = false;
    this.isAccountManager = false;
    this.downloadLoading = false;
    this.assignedBranches = [] || null;
    this.isSuperAdmin = false;
    this.isPaymentManager = false;
    this.startDate = '';
    this.endDate = '';
    this.accountManagers = {};
    this.accountManagerOptions = [];
    // ═══════════════════ EDIT DATE STATE ═══════════════════
    this.dialogDateFormVisible = false;
    this.dateSaving = false;
    this.selectedRowForDate = null;
    this.dateForm = {
      createdTimestamp: ''
    };
    // ════════════════════════════════════════════════════════
    this.listQuery = {
      page: 1,
      limit: 50,
      dealerId: undefined,
      agentId: undefined,
      branchId: undefined,
      applyBranchIdFilter: true,
      paymentType: 'Payment',
      action: 'credit',
      createdBy: undefined,
      approvalStatus: 'Approved',
      createdTimestamp: undefined,
      sort: 'id,ASC',
      filter: {
        agentId: '$eq',
        branchId: '$eq',
        dealerId: '$eq',
        approvalStatus: '$eq',
        createdTimestamp: 'between',
        paymentType: '$eq',
        action: '$eq',
        createdBy: '$eq'
      }
    };
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
    this.paymentMethods = [{
      label: 'Payment',
      key: 'Payment'
    }, {
      label: 'Credit Note',
      key: 'Credit Note'
    }, {
      label: 'Credit Note-Item Wise',
      key: 'Credit Note-Item Wise'
    }, {
      label: 'Sales Inwards',
      key: 'Sales Inwards'
    }];
    // ════════════════════════════════════════════════════════
  }
  async activated() {
    if (AdminModule.roles.includes('Account Manager')) {
      this.isAccountManager = true;
      // set createdBy filter for account manager to fetch only his data
    }
    if (isPaymentManager()) {
      this.isPaymentManager = true;
      this.listQuery.paymentType = 'Payment';
    }
    if (isSuperAdmin() || isPaymentManager()) {
      this.isSuperAdmin = true;
      this.listQuery.isSuperAdmin = this.isSuperAdmin;
    }
    // get logged in admin
    this.loggedInAdmin = AdminModule;
    if (this.loggedInAdmin.id === 1) {
      this.listQuery.paymentType = undefined;
    }
    // Assign branchId using BranchAgentService
    this.assignedBranches = await BranchAgentService.assignBranchId();
    // Check if branchId is null and throw an error
    if (this.assignedBranches === null) {
      throw new Error('You are not assigned to a branch.');
    }
    // Fetch agents for the assigned branchId
    this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
    this.dateRange = {
      start: this.$moment('2024-11-27').format('YYYY-MM-DD 00:00') + ' am',
      end: this.$moment().endOf('day').format('YYYY-MM-DD 11:59') + ' pm'
    };
    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.dateRange = {
        start: this.$route.query.startDate,
        end: this.$route.query.endDate
      };
    }
    // fetch agent list
    // this.getAgentList();
    // check if logged in user is Agent/Admin
    if (AdminModule.userType === 'Agent') {
      this.isAgent = true;
      this.listQuery.agentId = AdminModule.agentId;
    }
    await this.getAccountManagers();
    await this.getList();
  }
  formatDate(timestamp) {
    if (!timestamp) return ''; // Handle null or undefined case
    const date = new Date(timestamp);
    // Format date as "DD-MM-YYYY"
    const formattedDate = date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC'
    });
    return formattedDate;
  }
  async getAccountManagers() {
    try {
      const accountManagers = await getAccountManagers();
      this.accountManagerOptions = [{
        label: 'SUPER ADMIN',
        key: 1
      }, ...accountManagers.map(item => ({
        label: item.fullName,
        key: item.id
      }))];
      this.accountManagers = {
        1: 'SUPER ADMIN',
        ...accountManagers.reduce((acc, item) => {
          acc[item.id] = item.fullName;
          return acc;
        }, {})
      };
    } catch (error) {
      console.error(error);
      throw new Error('Failed to Fetch Account Managers');
    }
  }
  async createEInvoice(id = 0) {
    // generate E-invoice
    try {
      this.listLoading = true;
      this.$confirm('Do you want to create E-invoice?', 'Create E-invoice', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        const generateEInvoiceResponse = await generateEInvoice(id);
        if (generateEInvoiceResponse && generateEInvoiceResponse.status === 'success') {
          this.$message({
            message: 'E-invoice created successfully',
            type: 'success'
          });
          // refresh list to display einvoice data
          this.getList();
        } else {
          this.$message({
            message: 'Failed to create E-invoice',
            type: 'error'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.listLoading = false;
    } catch (err) {
      this.listLoading = false;
    }
  }
  async createInvoice(id = 0) {
    // generate invoice
    try {
      this.listLoading = true;
      this.$confirm('Do you want to create Invoice?', 'Create Iinvoice', {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'No',
        type: 'error'
      }).then(async () => {
        const generateEInvoiceResponse = await generateInvoice(id);
        if (generateEInvoiceResponse && generateEInvoiceResponse.status === 'success') {
          this.$message({
            message: 'Invoice created successfully',
            type: 'success'
          });
          // refresh list to display einvoice data
          this.getList();
        } else {
          this.$message({
            message: 'Failed to create Invoice',
            type: 'error'
          });
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Request Cancel'
        });
      });
      this.listLoading = false;
    } catch (err) {
      this.listLoading = false;
    }
  }
  async getList() {
    try {
      this.listQuery = cleanListQuery(this.listQuery);
      if (this.dateRange) {
        this.startDate = this.dateRange.start;
        this.endDate = this.dateRange.end;
        this.listQuery.createdTimestamp = [this.startDate, this.endDate].join(',');
      } else {
        this.listQuery.createdTimestamp = undefined;
      }
      this.listLoading = true;
      const data = await getPendingPaymentLedgerList(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    } finally {
      this.listLoading = false;
    }
  }
  async fetchBranches(superAdmin = true) {
    this.branchListLoading = true;
    // Base query
    const query = {
      enabled: true,
      sort: 'name,ASC'
    };
    //  filter only if superAdmin is false
    if (superAdmin === false) {
      if (this.listQuery.branchId.length === 0) {
        this.listQuery.branchId = AdminModule.branchIds;
      }
      query.id = this.listQuery.branchId;
      query.filter = {
        enabled: 'eq',
        id: '$in'
      };
    }
    // Fetch branch list
    this.branchList = await getBranches(getQuery(query));
    this.branchListLoading = false;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async fetchAgentsBranch(branchId) {
    try {
      if (this.listQuery.branchId === '') {
        branchId = AdminModule.branchIds;
      }
      this.agentList = await getAgentsBranchWise(getQuery({
        enabled: true,
        sort: 'name,ASC',
        branchId
      }));
    } catch (error) {}
  }
  async getDealerById(dealerId = null) {
    this.dealerListLoading = true;
    const data = await getDealerById(dealerId);
    if (data) {
      this.dealerList = [data];
    }
    this.dealerListLoading = false;
  }
  async getAgentList(query = null) {
    try {
      this.agentList = await getAgents(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async handleClearBranch() {
    // Assign branchId using BranchAgentService
    this.listQuery.branchId = await BranchAgentService.assignBranchId();
    // Fetch branches for non-super admin users
    this.branchList = await BranchAgentService.fetchBranches(this.listQuery.branchId);
  }
  async handleFilter() {
    var _AdminModule$branchId;
    this.listQuery.page = 1;
    // handle branch and agent code
    // Fetch agents for a single branch
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.paymentType === 'Sales Inwards') {
      this.listQuery.paymentType = 'Purchase,Credit Note Inward';
      this.listQuery.filter.paymentType = '$in';
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      // Fetch agents and branches for non-superadmin/admin users
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      // Fetch the list after agents and branches are loaded
      this.getList();
    } else {
      // await this.handleClearBranch();
      this.getList();
    }
  }
  async viewPdf(params, showMerged = false) {
    try {
      // get invoice url
      this.listLoading = true;
      let url;
      if (showMerged) {
        url = params.ledgerAttachmentS3Url;
      } else {
        if (params.paymentType === 'Credit Note' || params.paymentType === 'Debit Note') {
          url = await viewCNDNInvoice(params.id);
        } else {
          url = await generateInvoice(params.id);
        }
      }
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message({
          message: 'Failed to generate invoice',
          type: 'error'
        });
      }
    } catch (error) {
      this.$message({
        message: 'An error occurred while generating the invoice',
        type: 'error'
      });
    } finally {
      this.listLoading = false;
    }
  }
  async fetchAllData() {
    try {
      // Create a new query object without the page and limit properties
      const {
        page,
        limit,
        ...queryWithoutPagination
      } = this.listQuery;
      // Make an API call to fetch all data
      const response = await getPendingPaymentLedgerList(getQuery(queryWithoutPagination));
      return response;
    } catch (error) {
      console.error('Error fetching all data:', error);
      return [];
    }
  }
  filterData(data, columns) {
    return data.map(item => {
      const filteredItem = {};
      columns.forEach(column => {
        const keys = column.split('.');
        let value = item;
        keys.forEach(key => {
          value = value ? value[key] : null;
        });
        filteredItem[column] = value;
      });
      return filteredItem;
    });
  }
  async exportToExcel() {
    try {
      const columnsToInclude = ['id', 'dealer.name', 'amount', 'paymentType', 'approvalStatus', 'comments', 'createdTimestamp'
      // Add other columns as needed
      ];
      const allData = await this.fetchAllData();
      // Create a custom array with only the desired columns
      const filteredData = this.filterData(allData, columnsToInclude);
      // Create a new workbook and a worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(filteredData);
      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(wb, ws, 'Approved Ledgers');
      // Generate a buffer
      const wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array'
      });
      // Create a Blob from the buffer
      const blob = new Blob([wbout], {
        type: 'application/octet-stream'
      });
      // Create a link element
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'approved_ledgers.xlsx';
      // Append the link to the body
      document.body.appendChild(link);
      // Trigger the download
      link.click();
      // Remove the link from the document
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
    }
  }
  // ═══════════════════ EDIT DATE METHODS ═══════════════════
  openDateEditDialog(row) {
    this.selectedRowForDate = row;
    this.dateForm.createdTimestamp = row.createdTimestamp;
    this.dialogDateFormVisible = true;
  }
  async saveDateEdit() {
    try {
      this.dateSaving = true;
      const formattedDate = moment(this.dateForm.createdTimestamp).utcOffset('+05:30').set({
        hour: 10,
        minute: 0,
        second: 0,
        millisecond: 0
      }).format('YYYY-MM-DD HH:mm:ss');
      await updateLedgerEntry(this.selectedRowForDate.id, {
        createdTimestamp: formattedDate
      });
      this.$message.success('Date updated successfully');
      this.dialogDateFormVisible = false;
      this.selectedRowForDate = null;
      this.getList();
    } catch (error) {
      this.$message.error('Error updating date');
    } finally {
      this.dateSaving = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'ApprovedPaymentLedgerList',
  components: {
    Pagination,
    Inr
  }
})], default_1);
export default default_1;